import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { MessageService } from 'primeng/api';
import { APIService } from './api.service';
import { MsalService } from '@azure/msal-angular';


@Injectable({
    providedIn: 'root'
})
export class AuthService {
    private userSubject = new BehaviorSubject<any>(null);
    favourites = [];
    favouriteIds = [];

    userName = "";

    constructor(private apiService: APIService, private router: Router, private messageService: MessageService, private authService: MsalService,) { }

    public isAuthenticated(): boolean {
        const token: any = localStorage.getItem('token');

        return !(token == null);
    }
    login(payload: any) {
        return this.apiService.post("/Auth/login", payload);
    }

    loginWithAd(payload: any) {
        return this.apiService.post("/Auth/LoginWithAd", payload);
    }

    public initLoggedInUser() {

        let userStringified = localStorage.getItem("userData");
        if (!this.isAuthenticated() || userStringified == null) {
            this.redirectTo("/auth/sign-in");
        }

        let user = JSON.parse(userStringified);
        this.userSubject.next(user);
    }

    public redirectTo(route) {
        this.router.navigate([route]);
    }

    public getUserToken() {
        const token = localStorage.getItem("token");

        return token;
    }

    public logout() {
        localStorage.removeItem("token");
        localStorage.removeItem("userData");
        this.userSubject.next(null);
        this.authService.logout().subscribe(x => {
            this.redirectTo("/auth/sign-in");
        });
    }


    public getCurrentUser(): Observable<any> {
        this.initLoggedInUser();
        // if (!this.userSubject || this.userSubject.getValue() === null) {
        //     this.initLoggedInUser();
        // }
        return this.userSubject.asObservable();
    }

    getOtpOnEmail(email: string) {
        return this.apiService.get(`/Auth/generateotp?email=${email}`);
    }

    verifyOtp(payload) {
        return this.apiService.post(`/Auth/verifyotp`, payload);
    }

    verifyDetails(payload) {
        return this.apiService.post(`/Auth/verifydetails`, payload);
    }

    resetPassword(payload) {
        return this.apiService.post(`/Auth/resetpassword`, payload);
    }
    getAllDirections() {
        return this.apiService.post(`/Auth/GetAllDirections`, undefined);
    }
    getAllDepartments() {
        return this.apiService.post(`/Auth/GetAllDepartment`, undefined);
    }
    getAllDepartmentByDirection(directionname: number) {
        return this.apiService.post(`/Auth/GetAllDepartmentbyDirection?directionname=${directionname}`, "");
    }
    getAllExpertisebyDepartment(departmentname: number) {
        return this.apiService.post(`/Auth/GetAllExpertisebyDepartment?departmentname=${departmentname}`, "");
    }
}
